<template>
    <Slide :title="title" :subtitle="subtitle">
        <div class="cr:grid cr:grid-cols-1 cr:md:grid-cols-2 cr:lg:grid-cols-3 cr:text-sm">
            <div v-for="carrier in carrierOptions" class="cr:flex cr:items-center cr:gap-2 cr:p-1 cr:my-1">
                <CustomCheckbox v-model="carrier.selected"/>
                <div class="cr:flex cr:items-center cr:gap-3">
                    <p>{{ carrier.name }}</p>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                         class="cr:h-6 cr:w-6 cr:text-blue-500 cr:cursor-pointer cr:font-bold"
                         v-if="otherSelected && carrier.value === 'Other'"
                         @click="addOtherCarrier">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/>
                    </svg>
                </div>
            </div>
            <div class="cr:md:col-span-2 cr:md:w-1/2 cr:lg:col-span-3 cr:lg:w-1/3 cr:mt-2" v-if="otherSelected" >
                <div v-for="(otherItem, index) in otherCarriers" :key="index" class="cr:flex cr:items-center cr:gap-2 cr:mb-3">
                    <CustomInput v-model="otherItem.value" :placeholder="'Enter carrier name'" class="cr:flex-1"></CustomInput>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                         class="cr:h-6 cr:w-6 cr:text-red-500 cr:cursor-pointer cr:flex-shrink-0"
                         @click="removeOtherCarrier(index)"
                         v-if="otherCarriers.length > 1">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
                    </svg>
                </div>
            </div>
        </div>
    </Slide>
</template>

<script setup lang="ts">
import Slide from "@/components/slides/Slide.vue";
import Dropdown from "@/components/elements/Dropdown.vue";
import {ref, computed} from "vue";
import {useErrorStore} from "@/stores/error.ts";
import CustomCheckbox from "@/components/elements/CustomCheckbox.vue";
import CustomInput from "@/components/elements/CustomInput.vue";

const carrierOptions = ref([
    { name: 'Allstate Ins Group', value: 'Allstate Ins Group', selected: false },
    { name: 'American Family Insurance Group', value: 'American Family Insurance Group', selected: false },
    { name: 'Berkshire Hathaway Ins', value: 'Berkshire Hathaway Ins', selected: false },
    { name: 'Chubb INA Group', value: 'Chubb INA Group', selected: false },
    { name: 'Farmers Ins Group', value: 'Farmers Ins Group', selected: false },
    { name: 'Hartford Ins Group', value: 'Hartford Ins Group', selected: false },
    { name: 'Liberty Mutual Ins Cos', value: 'Liberty Mutual Ins Cos', selected: false },
    { name: 'Nationwide Group', value: 'Nationwide Group', selected: false },
    { name: 'Progressive Ins Groupg', value: 'Progressive Ins Group', selected: false },
    { name: 'State Farm Group', value: 'State Farm Group', selected: false },
    { name: 'Travelers Group', value: 'Travelers Group', selected: false },
    { name: 'USAA Group', value: 'USAA Group', selected: false },
    { name: 'Other', value: 'Other', selected: false },
]);

const otherCarriers = ref([{ value: '' }]);
const errorStore = useErrorStore();

const props = defineProps({
    title: {
        type: String,
        default: "Which carrier(s) will you use to quote leads from us?"
    },
    subtitle: {
        type: String,
        default: ''
    }
});

const slidePayload = computed(() => {
    const carriers = selectedCarriers.value.filter(carrier => carrier.value !== 'Other').map(carrier => carrier.value);
    
    if (otherSelected.value) {
        carriers.push(...otherCarriers.value.map(carrier => carrier.value));
    }
    
    return {
        carriers: carriers,
    }
});
const validate = () => {
    if (!selectedCarriers.value.length) {
        errorStore.report('Please select carrier(s).');
        return false;
    }
    
    if (otherSelected.value && otherCarriers.value.some(carrier => !carrier.value.trim().length)) {
        errorStore.report('Please enter the name of the carrier.')
        return false;
    }
    
    return true
}
const canContinue = computed(() => true);
const otherSelected = computed(() => carrierOptions.value.find(carrier => carrier.value === 'Other')?.selected);
const selectedCarriers = computed(() => carrierOptions.value.filter(carrier => carrier.selected));

defineExpose({
    canContinue,
    slidePayload,
    validate
});

const addOtherCarrier = () => {
    otherCarriers.value.push({ value: '' });
};

const removeOtherCarrier = (index: number) => {
    otherCarriers.value.splice(index, 1);
};

</script>